import React from 'react'
import { APP_NAME } from 'configs/AppConfig';
import { useTranslation } from 'react-i18next';
import { FaInstagram, FaLifeRing, FaTwitter } from 'react-icons/fa';

export default function Footer() {
	const { t, i18n } = useTranslation();
	return (
		<>
		</>
		// <footer style={{ background: "#1E1E1E", height: "60px", margin: "0px" }} className="footer">
		// 	<div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-4">
		// 		<span className="text-sm text-white">
		// 			&copy; {new Date().getFullYear()} <span className="font-semibold text-white">Chatshire</span>. All rights reserved.
		// 		</span>
		// 	</div>
		// 	<div className="text-center mt-2 flex items-center justify-center space-x-2">
		// 		<FaLifeRing className="text-gray-400 text-lg" />
		// 		<a
		// 			style={{ color: "white" }}
		// 			href="https://www.chatshire.io/contact"
		// 			className="text-gray-400 hover:text-white transition duration-200"
		// 		>
		// 			Destek İçin: https://www.chatshire.io/contact
		// 		</a>
		// 	</div>
		// </footer>
	)
}

